import React from 'react';
const AudioItemSkeleton = () => (
  <div className="flex items-start space-x-4 animate-pulse">
    <div className="w-[100px] h-[100px] rounded-2xl bg-gray-300" />
    <div className="flex-1 space-y-2 py-1">
      <div className="h-4 bg-gray-300 rounded w-3/4" />
      <div className="h-3 bg-gray-200 rounded w-1/3" />
    </div>
  </div>
);

const AudioListSkeleton = () => {
  return (
    <div className="space-y-6 ">
      {Array.from({length: 3}).map((_, idx) => (
        <AudioItemSkeleton key={idx} />
      ))}
    </div>
  );
};

export default AudioListSkeleton;
